// Typelizer digest d240ab88978bebf918237df12a30b3a9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** PATCH /group */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/group', {}, options),
    method: 'patch',
  }),
}
